import INotifyErrors from '../../interfaces/INotifyErrors';
import errorsMap from './errorsMap';

const notifyErrors = ({ err: { details }, fields: fieldsState }: INotifyErrors): void => {
  Array.isArray(details) &&
    details.forEach(({ field, messages }) => {
      const errorMsg =
        Array.isArray(messages) &&
        messages
          .map((message) => (errorsMap[message] && errorsMap[message][field]) || message)
          .join('. ');
      if (!fieldsState[field]) {
        console.warn('Unknown field', field, messages);
      } else {
        fieldsState[field].onSubmit(errorMsg);
      }
    });
};

export default notifyErrors;
